module.exports = __webpack_public_path__ + "img/equipos-sala.416a08a6.jpg";